export default __webpack_public_path__ + "static/media/logo_filled_font_lower.24d54ac5.png";